import dayjs from 'dayjs';
import { TFunction } from 'i18next';

import { EItineraryTimeChange, formatDate } from '@mopla/utils';

export type TRelativeDay =
	| 'past'
	| 'yesterday'
	| 'today'
	| 'tomorrow'
	| 'future';

export function getRelativeDay(
	date: Date | string,
	now: Date = new Date()
): TRelativeDay {
	const diffInDays = dayjs(date)
		.startOf('day')
		.diff(dayjs(now).startOf('day'), 'day');

	if (diffInDays === -1) return 'yesterday';
	if (diffInDays === 0) return 'today';
	if (diffInDays === 1) return 'tomorrow';

	return diffInDays < 0 ? 'past' : 'future';
}

/** Only the adjacent days carry a word prefix; the rest are plain dates. */
const PREFIXED_DAYS: TRelativeDay[] = ['yesterday', 'today', 'tomorrow'];

export function getRelativeDateLabel(
	date: Date | string,
	t: TFunction,
	now: Date = new Date()
): string {
	const relativeDay = getRelativeDay(date, now);
	const preset =
		relativeDay === 'future' ? 'weekDayDateNumeric' : 'dateNumeric';

	return t('common:text.date.relative', {
		context: PREFIXED_DAYS.includes(relativeDay) ? relativeDay : undefined,
		date: formatDate(date, preset),
	});
}

/**
 * Time changes worth painting the time in. An allow-list on purpose: a minor
 * delay is deliberately left alone, and a future enum member must opt in.
 */
const HIGHLIGHTED_TIME_CHANGES: ReadonlyArray<EItineraryTimeChange> = [
	EItineraryTimeChange.DELAY,
	EItineraryTimeChange.INDETERMINATE_DELAY,
	EItineraryTimeChange.EARLIER,
];

export const checkIsTimeChangeHighlighted = (
	type: EItineraryTimeChange
): boolean => HIGHLIGHTED_TIME_CHANGES.includes(type);
